<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>post_add</v-icon>
        <v-toolbar-title class="font-weight-light"
          >Manejo de Comprobantes Internos</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="empresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="De la Empresa:"
              placeholder="Seleccione una"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.sucursalId"
              :items="sucursales"
              item-text="nombre"
              item-value="id"
              label="Originadas en:"
              placeholder="Seleccione una"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.tipoComprobanteId"
              :items="listTiposComprobante"
              item-text="descripcion"
              item-value="id"
              label="Tipo:"
              placeholder="Seleccione uno"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <app-selector-periodos
              v-on:update-periodo="filtro.periodo = $event"
              :column="true"
            ></app-selector-periodos>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="3">
            <v-text-field
              v-model="filtro.cui"
              label="Buscar por documento/cuil"
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="3">
            <v-btn color="success" @click="getItems(true)">Traer Casos</v-btn>
          </v-col>
        </v-row>

        <v-flex>
          <v-card>
            <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
              <v-icon>list</v-icon>
              <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-data-table
              dense
              :headers="headers"
              :items="records"
              :server-items-length="totalItems"
              :rows-per-page="pagination.rowsPerPage"
              :options.sync="pagination"
              v-model="selectedRow"
              :loading="loading"
              class="elevation-1"
              :footer-props="footer"
              item-key="id"
            >
              <template v-slot:no-data>
                <v-alert
                  v-if="!primeraBusquedaRealizada"
                  :value="true"
                  color="grey lighten-3"
                  icon="info"
                >
                  Ingrese los filtros para realizar la búsqueda
                </v-alert>
                <v-alert v-else :value="true" color="grey" icon="warning">
                  No se encontraron datos
                </v-alert>
              </template>
              <template v-slot:item="{ item }">
                <tr
                  :key="item.id"
                  @click="selectRow(item)"
                  :class="{ selectedRow: item === selectedRow[0] }"
                >
                  <td>
                    <app-acciones-comunes
                      :personaId="item.personaId"
                      :documento="item.personaCui.substring(2, 10)"
                    >
                    </app-acciones-comunes>
                  </td>

                  <td class="text-xs-left caption">{{ item.tipo }}</td>
                  <td class="text-xs-left caption">{{ item.numero }}</td>
                  <td class="text-xs-left caption">
                    {{
                      item.fecha
                        | dateParse('YYYY-MM-DD')
                        | dateFormat('DD-MM-YYYY')
                    }}
                  </td>
                  <td class="text-xs-left caption">
                    {{ item.importe | currency }}
                  </td>
                  <td class="text-xs-left caption">{{ item.personaNombre }}</td>
                  <td class="text-xs-left caption">{{ item.personaCui }}</td>
                  <td class="text-xs-left caption">{{ item.comentarios }}</td>
                  <td class="text-xs-left caption">
                    <v-chip small :color="item.empresaColor" label dark>{{
                      item.empresaShort
                    }}</v-chip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
          <v-row dense v-if="records.length > 0">
            <v-col cols="2" class="mt-2">
              <v-btn @click="procesarArchivo()" color="green" dark
                >Exportar Listado</v-btn
              >&nbsp;
            </v-col>
            <v-col cols="1">
              <v-text-field
                v-model="filtro.separador"
                label="Separador"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-flex>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row dense>
            <v-col>
              <v-btn
                v-if="
                  selectedRow.length > 0 && selectedRow[0].estado != 'Anulada'
                "
                @click.stop="anular(selectedRow[0])"
                color="red"
                dark
              >
                Anular</v-btn
              >&nbsp;
              <v-btn
                v-if="selectedRow.length > 0 && selectedRow[0].tipo == 'Quita'"
                @click.stop="imprimir()"
                color="blue"
                dark
              >
                Imprimir &nbsp;<v-icon>print</v-icon></v-btn
              >&nbsp;
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn @click.stop="altaQuita()" color="brown" dark>
                Dar de Alta una Quita</v-btn
              >&nbsp;
              <v-btn @click.stop="altaCargo()" color="indigo" dark>
                Dar de Alta un Cargo</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <!-- Ver Legajo Cliente  -->
    <v-dialog v-model="showLegajoPersona" width="1000">
      <legajo-persona :personaId="selectedPersonaId"> </legajo-persona>
    </v-dialog>

    <!-- Ver Legajo Virtual  -->
    <v-dialog v-model="showLegajoVirtual" persistent width="700">
      <legajo-virtual
        :personaId="selectedPersonaId"
        @close-dialog="showLegajoVirtual = false"
      >
      </legajo-virtual>
    </v-dialog>

    <!-- <app-loading :loading="componentsLoading"></app-loading> -->

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ filtro }}
      <p></p>
    </template>
  </v-container>
</template>

<style scoped>
.selectedRow {
  background-color: greenyellow;
  font-weight: bold;
}
</style>

<script>
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

import LegajoPersona from '@/components/legajo/layout.vue';
import LegajoVirtual from '@/components/legajo/legajoVirtual.vue';

export default {
  components: {
    'legajo-persona': LegajoPersona,
    'legajo-virtual': LegajoVirtual,
  },
  data() {
    return {
      primeraBusquedaRealizada: false,
      loading: false,
      suspend: false,
      filterChanged: false,
      search: '', // valor para búsqueda
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 20, 50],
      },
      totalItems: 0, // va afuera de pagination
      headers: [
        // definición de columnas
        { text: 'Ver', value: 'accion', width: 80, sortable: false },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Numero', value: 'numero' },
        { text: 'Fecha', value: 'fecha', width: 130 },
        { text: 'Importe', value: 'importe', width: 130 },
        { text: 'Se hizo a', value: 'personaNombre' },
        { text: 'Cuil', value: 'personaCui' },
        { text: 'Comentarios', value: 'comentarios' },
        { text: 'Empresa', value: 'empresa' },
      ],
      records: [], // registros
      selectedRow: [],
      filtro: {
        empresaId: 0,
        sucursalId: 0,
        tipoComprobanteId: 0,
        cui: 0,
        periodo: { id: 1 },
        separador: ';',
      },
      //selectedCaso: {creditosEnMora:[],telefonos:[],otrasGestiones:[]},
      empresas: [],
      sucursales: [],
      listTiposComprobante: [],
      showDetalle: false,
      showLegajoPersona: false,
      showLegajoVirtual: false,
      selectedPersonaId: '',
      selectedPersonaDocumento: '',
      selectedPersona: {},
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadSucursales();
    this.loadTiposComprobante();
  },
  watch: {
    pagination: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getItems(false);
      },
      deep: true,
    },
    search() {
      this.getItems(true);
    },
    activeTask: function() {
      //closeRelatedTasks es una variable del state que la pongo en true cuando se cierra el coso de activeTask y quiero cerrar otras cosas relacionadas
      if (this.closeRelatedTasks) {
        this.showDetalle = false;
        this.getItems(false);
      }
    },
  },
  computed: {
    ...mapGetters([
      'activeTask',
      'getActionFromLink',
      'user',
      'closeRelatedTasks',
    ]),
    action: function() {
      return this.getActionFromLink(this.$route.path);
    },
    /*  componentsLoading: function(){
      return this.loadingCreditosEnMora || this.loadingTelefonos || this.loadingGestionesTelefonicas || this.loadingOtrasGestiones;
    } */
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    selectRow(item) {
      if (this.selectedRow[0] === item) {
        this.selectedRow.pop();
      } else {
        this.selectedRow.pop();
        this.selectedRow.push(item);
      }

      console.log(this.selectedRow);
    },
    async getItems(resetPagination) {
      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtro;

      filter.cui = filter.cui ? filter.cui : 0;

      let incluirNotasCredito =
        filter.tipoComprobanteId == 0 || filter.tipoComprobanteId == 1;
      let incluirNotasDebito =
        filter.tipoComprobanteId == 0 || filter.tipoComprobanteId == 2;

      try {
        var result = await http.get(
          'comprobantes/listquitascargos?empresaId=' +
            filter.empresaId +
            '&sucursalId=' +
            filter.sucursalId +
            '&incluirNotasCredito=' +
            incluirNotasCredito +
            '&incluirNotasDebito=' +
            incluirNotasDebito +
            '&fechaDesde=' +
            filter.periodo.desde +
            '&fechaHasta=' +
            filter.periodo.hasta +
            '&documento=' +
            filter.cui +
            '&limit=' +
            this.pagination.itemsPerPage +
            '&page=' +
            this.pagination.page +
            '&sortby=' +
            this.pagination.sortBy +
            '&descending=' +
            (this.pagination.sortDesc.length > 0
              ? this.pagination.sortDesc
              : 'false')
        );

        Vue.$log.debug(result.list);
        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;

      if (this.selectedRow.length > 0) {
        this.selectedRow.pop();
      }
    },
    async loadPersona(personaId) {
      this.loading = true;
      try {
        var result = await http.get('personas/' + personaId);

        this.selectedPersona = result;

        // trato las fechas
        var dob = this.$moment(this.selectedPersona.fechaNacimiento).format(
          'YYYY-MM-DD'
        );
        this.selectedPersona.fechaNacimiento = dob;

        if (this.selectedPersona.empleo != null) {
          var fi = this.$moment(
            this.selectedPersona.empleo.fechaIngreso
          ).format('YYYY-MM-DD');
          this.selectedPersona.empleo.fechaIngreso = fi;
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async verLegajo(item) {
      this.selectedPersonaId = item.personaId;
      this.showLegajoPersona = true;
    },
    async verLegajoVirtual(item) {
      this.selectedPersonaId = item.personaId;
      //this.selectedPersonaDocumento = item.documento.toString();
      this.showLegajoVirtual = true;
    },
    async verContactos(item) {
      this.selectedPersonaId = item.personaId;
      this.showListaCreditos = true;

      var params = {
        width: 700,
        visible: true,
        personaId: item.personaId,
      };

      this.setActiveTask({ task: 'app-log-contactos', props: params });
    },
    async verCreditos(item) {
      this.selectedPersonaId = item.personaId;

      var params = {
        width: 900,
        visible: true,
        personaId: item.personaId,
      };

      this.setActiveTask({ task: 'app-lista-creditos', props: params });
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );

        this.empresas = result.list;
        this.empresas.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          'sucursales/list/porusuario?usuarioId=' + this.user.id
        );

        this.sucursales = result.list;

        this.sucursales.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposComprobante() {
      this.listTiposComprobante.push({ id: 0, descripcion: '(Todos)' });
      this.listTiposComprobante.push({ id: 1, descripcion: 'Quitas' });
      this.listTiposComprobante.push({ id: 2, descripcion: 'Cargos' });
    },
    async anular(item) {
      if (item.tienePagos) {
        this.alertWarning(
          'No se puede realizar la anulación porque el comprobante tiene pagos asociados.'
        );
        return;
      }

      var motivo = prompt(
        'Se va a realizar la anulación del comprobante. Si desea confirmar ingrese el motivo y presione aceptar'
      );

      if (motivo) {
        var params = {
          transaccionId: item.transaccionId,
          motivo: 'wea',
        };

        this.saving = true;
        try {
          await http.put(
            'businesscore/anulartransaccion',
            JSON.stringify(params)
          );

          this.alertSuccess('El comprobante ha sido anulado.');
        } catch (error) {
          // Error
          this.alertError(error);
        }
        this.saving = false;
      }
    },
    async procesarArchivo() {
      let recordsArchivo = [];

      try {
        this.loading = true;

        this.$validator.reset();

        let filter = this.filtro;

        filter.cui = filter.cui ? filter.cui : 0;

        let incluirNotasCredito =
          filter.tipoComprobanteId == 0 || filter.tipoComprobanteId == 1;
        let incluirNotasDebito =
          filter.tipoComprobanteId == 0 || filter.tipoComprobanteId == 2;

        try {
          var result = await http.get(
            'comprobantes/listquitascargos?empresaId=' +
              filter.empresaId +
              '&sucursalId=' +
              filter.sucursalId +
              '&incluirNotasCredito=' +
              incluirNotasCredito +
              '&incluirNotasDebito=' +
              incluirNotasDebito +
              '&fechaDesde=' +
              filter.periodo.desde +
              '&fechaHasta=' +
              filter.periodo.hasta +
              '&documento=' +
              filter.cui +
              '&limit=' +
              this.totalItems +
              '&page=' +
              this.pagination.page +
              '&sortby=' +
              this.pagination.sortBy +
              '&descending=' +
              (this.pagination.sortDesc.length > 0
                ? this.pagination.sortDesc
                : 'false')
          );

          recordsArchivo = result.list;
        } catch (error) {
          // Error
          this.alertError(error);
        }

        var parametros = [];

        for (let i = 0; i < recordsArchivo.length; i++) {
          var data = {
            tipo: recordsArchivo[i].tipo,
            numero: recordsArchivo[i].numero,
            fecha: recordsArchivo[i].fecha,
            importe: recordsArchivo[i].importe,
            importePunitorios: recordsArchivo[i].importePunitorios,
            seHizoA: recordsArchivo[i].personaNombre,
            cuil: recordsArchivo[i].personaCui,
            empresa: recordsArchivo[i].empresaNombre,
            numeroOperacion: recordsArchivo[i].numeroOperacion,
            canalVenta: recordsArchivo[i].canalVenta,
            responsable: recordsArchivo[i].responsable,
            comentarios: recordsArchivo[i].comentarios,
          };

          parametros.push(data);
        }

        console.log(parametros);
        console.log(this.filtro.separador);

        await http
          .post(
            'filegeneration/comprobantesinternos',
            JSON.stringify({
              listaData: parametros,
              separador: this.filtro.separador,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              this.alertError(resp.error);
            } else {
              this.alertSuccess(
                'Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo...'
              );

              this.loading = true;
              this.downloadFile(resp, 'ManejoComprobantesInternos.csv');
              this.loading = false;
            }
          })
          .catch((e) => {
            this.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async downloadFile(file, renameTo) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = '';
      base64String = btoa(file.fullPath);

      http
        .get('filemanagement/getfilebypath/' + base64String)
        .then((resp) => {
          let dataType = '';
          switch (resp.extension) {
            case '.doc':
            case '.docx':
            case '.DOC':
            case '.DOCX':
              dataType = 'data:application/vnd.ms-word';
              break;
            case '.pdf':
            case '.PDF':
              dataType = 'data:application/pdf';
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(renameTo, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    altaQuita() {
      var params = {
        width: 900,
        visible: true,
      };

      this.setActiveTask({ task: 'app-alta-quitas', props: params });
    },
    altaCargo() {
      var params = {
        width: 900,
        visible: true,
      };

      this.setActiveTask({ task: 'app-alta-cargos', props: params });
    },
    imprimir() {
      let params = [];

      var listaIds = '';

      for (let i = 0; i < this.selectedRow.length; i++) {
        const item = this.selectedRow[i];
        if (listaIds != '') listaIds = listaIds + ',';
        listaIds = listaIds + item.id;
      }

      params.push({
        ListaIds: listaIds,
      });

      this.setReporteActivo({
        reporte: 'ComprobanteNoFiscal.trdp',
        params: params,
      });
      window.open('/report-viewer');
    },
  },
};
</script>
